import { Button, Form } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";

import "./SearchEntry.scss";

interface SearchEntryProps {
  defaultValue: string,
  onSearch: (searchValue : string) => void
}

const SearchEntry = ({ defaultValue, onSearch } : SearchEntryProps) => {
  const {
    formState: { errors }, register, handleSubmit, getValues, setValue
  } = useForm({
    mode: "onSubmit"
  });

  const handleOnChange = (e: any) => {
    if (e.target.value === "") {
      onSearch("");
    }

    setValue("searchText", e.target.value);
  };

  const handleSearchClick = () => {
    onSearch(getValues("searchText"));
  };

  return (
    <span>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit(handleSearchClick)}>

        <Form.Control
          {...register("searchText")}
          data-testid="txtSearchEntry"
          type="search"
          className="input-search"
          aria-required="true"
          aria-label="textual search"
          aria-invalid="false"
          placeholder="Search for....."
          defaultValue={defaultValue}
          onChange={e => handleOnChange(e)}
        />
        <Button
          data-testid="btnSearchEntry"
          aria-label="Search"
          type="submit"
        >
          <Search />
        </Button>
      </Form>
    </span>
  );
};

export default SearchEntry;
